import React from 'react';

interface Props {
	EmailCount: number;
	Role: any;
}

const InterviewScheduledModal = ({ EmailCount, Role }: Props) => {
	return (
		<div className="flex bg-[#FFF] rounded-[8px] justify-center">
			<div className="">
				<div className="max-w-[60px] max-h-[60px] mx-auto mt-[64px]">
					<img src="/assets/assessmentcompleted/circle.svg" className="w-full h-full" />
				</div>
				<div className="flex flex-col justify-center items-center gap-[16px] py-4 px-4 md:py-[32px] md:px-[42px]">
					<p className="text-center font-inter text-lg md:text-2xl font-[500] text-[#7777E7]">
						Assessment Invitations Sent!
					</p>
					<p className="text-center font-inter text-xs md:text-sm font-medium inline-block text-[#555770] px-[43px] pb-[60px]">
						<strong>{EmailCount}</strong> candidates have been invited to complete the <strong>{Role}</strong>{' '}
						Assessment
					</p>
				</div>
			</div>
		</div>
	);
};

export default InterviewScheduledModal;
